export default __webpack_public_path__ + "images/modooda_logo.png";